import React, { useState } from "react";
import AudioPlayer from "./AudioPlayer";

const sounds = [
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
];

const SoundListPage: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    if (currentIndex < sounds.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1>Sound Player</h1>
      <AudioPlayer key={currentIndex} src={sounds[currentIndex]} />
      <div style={{ marginTop: "20px" }}>
        <button
          onClick={handlePrev}
          disabled={currentIndex === 0}
          style={{
            marginRight: "10px",
            padding: "10px 20px",
            backgroundColor: "#1DB954",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: currentIndex === 0 ? "not-allowed" : "pointer",
          }}
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          disabled={currentIndex === sounds.length - 1}
          style={{
            padding: "10px 20px",
            backgroundColor: "#1DB954",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor:
              currentIndex === sounds.length - 1 ? "not-allowed" : "pointer",
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SoundListPage;
